export default __webpack_public_path__ + "static/media/svg-9.fae1804a.svg";